import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import Icons from "../../myIcon/Icons";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { BaseUrl } from '../../helper/BaseUrl';

export default function GalleryFilter({initialData}) {

  const { gallery_slug } = useParams();
  const [galleryData, setGalleryData] = useState(initialData || {});
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("all");

  const [visibleCount, setVisibleCount] = useState(5);
  useEffect(() => {
    setVisibleCount(5);
  }, [activeFilter]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 300
      ) {
        setVisibleCount((prev) => prev + 5);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const filteredImages =
  activeFilter.toLowerCase() === "all"
    ? [...new Set(Object.values(galleryData).flat())]
    : galleryData[activeFilter] || [];


  useEffect(() => {
    let fb;
    if (typeof window !== "undefined") {
      import("@fancyapps/ui").then((mod) => {
        fb = mod.Fancybox;
        fb.bind("[data-fancybox='gallery']", {});
      });
    }

    return () => {
      if (fb) {
        fb.destroy();
      }
    };
  }, []);

  useEffect(() => {
    const aifetcher = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/gallery-details/${gallery_slug}`, {
          method: 'GET',
        });
        const result = await response.json();
        if (!result.data) {
          navigate("/404", { replace: true });
          return;
        }
        setGalleryData(result.data);
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };
    aifetcher();
  }, [gallery_slug, navigate]);

  
  // Custom category order
  const customOrder = [
    "Rooms",
    "Dining",
    "Bar",
    "Reception",
    "Conference",
    "Outdoor",
    "SPA",
    "Wedding",
  ];

  // Sort filters
  const filters = Object.keys(galleryData).sort((a, b) => {

    // Always keep All first
    if (a.toLowerCase() === "all") return -1;
    if (b.toLowerCase() === "all") return 1;

    const indexA = customOrder.indexOf(a);
    const indexB = customOrder.indexOf(b);

    // both not found → alphabetical
    if (indexA === -1 && indexB === -1) {
      return a.localeCompare(b);
    }

    // unknown categories go last
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    // custom order
    return indexA - indexB;
  });

  return (
    <>

      <section className="gallery-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12">
              <div className="page-filter">
                {/* Desktop Filter */}
                <ul>
                  {filters?.map((item, index) => (
                    <li key={index} className={activeFilter.toLowerCase() === item.toLowerCase() ? "active" : ""}
                      onClick={() => handleFilterClick(item)}><Link> {item} </Link></li>
                  ))}
                </ul>
                {/* mobile Filter */}
                <div className="filter-dropdown">
                  <span>Select Gallery Filter</span>
                  <select className="form-control" value={activeFilter} onChange={(e) => handleFilterClick(e.target.value)}>
                    {filters?.map((item, index) => (
                      <option key={index} value={item}>{item}</option>
                    ))}
                  </select>
                </div>
              </div>

              <p className='sr-only'>Luxury Stays, Scenic Stays</p>
            </div>

            <div className="gallery-col">
              <div className="col-md-12">
                <div className="small-image row">
                  {filteredImages?.slice(0, visibleCount)?.map((img, index) => {
                    const position = index % 5;
                    const colClass =   position < 3 ? "col-lg-4 col-md-4" : "col-lg-6 col-md-6";
                    return (
                      <div className={colClass} key={index}>
                        <a href={BaseUrl + img} data-fancybox="gallery" className="gallery-image">
                          <img src={BaseUrl + img} alt="gallery" className="img-responsive" />
                          <span><Icons name="expand" /></span>
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  )
}
